var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center min-h-screen py-8"},[_c('Container',{staticClass:"w-full max-w-prose"},[_c('NumServerLogo',{staticClass:"w-12 h-12 mb-4 text-gray-400"}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }